import NotificationsRequest from '@/components/NotificationsRequest';
import { FirebaseMessaging } from '@capacitor-firebase/messaging';
import { Camera, CameraResultType } from '@capacitor/camera';
import { Haptics, ImpactStyle } from '@capacitor/haptics';
import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonList,
  IonModal,
  IonPage,
  IonTitle,
  IonToolbar
} from '@ionic/react';
import React, { useState } from 'react';
import { useHistory } from 'react-router';

const DebugPage: React.FC = () => {
  const history = useHistory();

  // Test Camera functionality
  const testCamera = async () => {
    try {
      const image = await Camera.getPhoto({
        quality: 90,
        allowEditing: true,
        resultType: CameraResultType.Uri,
      });
      console.log('Camera image:', image);
    } catch (error) {
      console.error('Error accessing camera:', error);
    }

  };

  // Test Haptics (vibration)
  const testVibration = async () => {
    try {
      await Haptics.impact({ style: ImpactStyle.Light });
      console.log('Haptics triggered');
    } catch (error) {
      console.error('Error triggering haptics:', error);
    }
  };

  // Test Firebase Messaging Permissions
  const [permissionsResult, setPermissionsResult] = useState<string | null>(null);
  const [showNotificationsRequest, setShowNotificationsRequest] = useState(false);

  const checkMessagingPermissions = async () => {
    try {
      const permissionStatus = await FirebaseMessaging.checkPermissions();
      console.log('Messaging permissions:', permissionStatus);
      setPermissionsResult(JSON.stringify(permissionStatus, null, 2));
    } catch (error) {
      console.error('Error checking messaging permissions:', error);
      setPermissionsResult(JSON.stringify({ error: error instanceof Error ? error.message : 'Unknown error' }, null, 2));
    }
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="danger">
          <IonButtons slot="start">
            <IonBackButton defaultHref="/dashboard" />
          </IonButtons>
          <IonTitle>Debug Page</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding bg-ba mt-32">
        <IonList>
          <IonButton className="w-full" onClick={testCamera}>
            Test Camera
          </IonButton>
          <IonButton className="w-full" onClick={testVibration}>
            Test Vibration
          </IonButton>
          <IonButton className="w-full" onClick={() => history.push('/welcome')}>
            (BROKEN) Redo Onboarding
          </IonButton>
          <IonButton className="w-full" onClick={checkMessagingPermissions}>
            Check Firebase Messaging Permissions
          </IonButton>
          <IonButton className="w-full" onClick={() => setShowNotificationsRequest(true)}>
            Force request notification permission
          </IonButton>
          <IonButton className="w-full" onClick={() => window.location.reload()}>
            Restart app
          </IonButton>
          <IonButton className="w-full" routerLink="/sentry-test">
            Sentry test
          </IonButton>
          {permissionsResult && (
            <div className="mt-4 p-4 border-input border rounded overflow-auto">
              <pre>{permissionsResult}</pre>
            </div>
          )}
        </IonList>

      </IonContent>
    </IonPage>
  );
};

export default DebugPage;